var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor","width":"24","height":"24"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }